import { render, staticRenderFns } from "./KeepReading.vue?vue&type=template&id=54f51b64&"
import script from "./KeepReading.vue?vue&type=script&lang=ts&"
export * from "./KeepReading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlockHorizontalList: require('/tmp/build_4600e676/src/components/block/HorizontalList.vue').default})
